import { Eye, X } from 'lucide-react'
import { useAuth } from '~/hooks/useAuth'
import { Button } from '~/components/ui/button'

export function ImpersonationBanner() {
  const { isImpersonated, user, handleStopImpersonation } = useAuth()

  if (!isImpersonated) return null

  return (
    <div className='sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white'>
      <Eye className='h-4 w-4 shrink-0' />
      <span>
        You are impersonating <strong>{user?.name}</strong>
      </span>
      <Button
        variant='ghost'
        size='sm'
        className='h-6 gap-1 bg-white/20 px-2 text-white hover:bg-white/30 hover:text-white'
        onClick={handleStopImpersonation}
      >
        <X className='h-3 w-3' />
        Stop
      </Button>
    </div>
  )
}
